(function () {
  "use strict";

  angular.module("PrintQueueProperties")

    .constant('PRINT_QUEUE_PROPERTIES_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-group',
        section: 'groups',
        caption: 'Groups',
        selected: false,
        show: false
      },
      {
        icon: 'icon-drivers',
        section: 'drivers',
        caption: 'Drivers',
        selected: false,
        show: true
      },
      {
        icon: 'icon-computer',
        section: 'computers',
        caption: 'Computers',
        selected: false,
        show: true
      },
    ])

    .controller("PrintQueuePropertiesController", [
        "$rootScope", "$scope", "URLS", "$location", "$filter", "$routeParams",
        "URL_PARAMS", "PrinterListService", "TenantListService", "toastr", "focus",
        "SUPPORTED_OS", "$http", "$ngBootbox", "PRINTER_TYPES", "PrintQueueListService",
        "EventServiceEvents", "WorkstationListPOSTPaging", "WorkstationListService", "NetworkListService",
        "SORT_WORKSTATIONS", "$timeout", "PrintQueueListPaging", "GroupListPaging", "GroupListService",
        "PRINT_QUEUE_PROPERTIES_TABS", 'EventHandlerService', 'currentTenant', 'PrintQueuePropertiesService',
      function (
        $rootScope, $scope, URLS, $location, $filter, $routeParams,
        URL_PARAMS, PrinterListService, TenantListService, toastr, $focus,
        SUPPORTED_OS, $http, $ngBootbox, PRINTER_TYPES, PrintQueueListService,
        EventServiceEvents, WorkstationListPOSTPaging, WorkstationListService,  NetworkListService,
        SORT_WORKSTATIONS, $timeout, PrintQueueListPaging, GroupListPaging, GroupListService,
        PRINT_QUEUE_PROPERTIES_TABS, EventHandlerService, currentTenant, PrintQueuePropertiesService) {

        $scope.printer = null;
        $scope.printQueue = null;
        $scope.printQueueOriginal = null;
        $scope.printQueuePropertiesForm = {};
        $scope.printerTypes = PRINTER_TYPES;
        $scope.printerUrl = null;
        $scope.tenant = currentTenant;
        $scope.notAnywherePrinterQueue = false;
        $scope.preferredWorkstationsList = [];

        //Computers **********************************************
        $scope.networkListService = NetworkListService;
        $scope.selectedWorkstations = 0;
        $scope.selectAllWorkstations = {selected: false}
        $scope.lastPageReached = false;
        $scope.filtersList = null;
        $scope.workstationListPaging = new WorkstationListPOSTPaging();
        $scope.workstationsForSystemAndUser = new WorkstationListPOSTPaging();
        $scope.requestType = 'GET';
        $scope.workstationContainer = null;
        $scope.searchInputPlaceholderText = 'SearchComputerByName';
        $scope.noDataMessage = 'NoComputers';
        $scope.orderWorkstationsByText = "HostName";
        $scope.reverseWorkstations = false;
        $scope.remoteQueueManagementCalibrationObject = {
          searchInputPlaceholderText: "SearchQueueByName"
        };
        $scope.supportedOsRaw = SUPPORTED_OS;
        $scope.isThisResourceMine = true;
        $scope.universalPrintEnabled = false;
        $scope.siblingsOccupyUniversalPrint = false;

        // Tooltips
        $scope.tooltip = {
          RenameDriverConfigurationTooltip: 'RenameDriverConfigurationTooltip',
          EditDriverConfigurationTooltip: 'EditDriverConfigurationTooltip',
          DeleteDriverConfigurationTooltip: 'DeleteDriverConfigurationTooltip',
          CreateDriverConfigurationTooltip: 'CreateDriverConfigurationTooltip',
          NonGroupUsersSettingsTooltip: 'NonGroupUsersSettingsTooltip',
          GroupExclusiveAccessWarningTooltip: 'GroupExclusiveAccessWarningTooltip',
          PrintQueueUpdateOnComputersTooltip: 'PrintQueueUpdateOnComputersTooltip'
        }

        $scope.eventHandlerService = EventHandlerService;

        (function(){
          initEventHandler();
          setListeners();

          if ($routeParams['queueSection']) {
            $scope.showSection = $routeParams['queueSection'];
          } else {
            $scope.showSection = 'setup';
          }
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.setSection = function(section) {
          $scope.showSection = section;

          var url = $location.path();
          $location.path(url, false).search({ queueSection: section });
        };

        function calibrateTabs() {
          for (var i = 0; i < PRINT_QUEUE_PROPERTIES_TABS.length; i++) {
            if (PRINT_QUEUE_PROPERTIES_TABS[i].section === 'groups') {
              PRINT_QUEUE_PROPERTIES_TABS[i].show = TenantListService.currentTenant.info.groupsEnabled
            }
          }
          $scope.tabs = PRINT_QUEUE_PROPERTIES_TABS;
        }

        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            getPrintQueue();
          }
        })


        // Help
        $scope.$watch(function () {
          return $scope.showSection;
        }, function () {
          if ($scope.showSection) {
            switch ($scope.showSection) {
              case 'setup':
                $scope.helpCaption = "HelpPrintQueuePropertiesSetup";
                break;
              case 'groups':
                $scope.helpCaption = 'HelpPrintQueuePropertiesGroups';
                break;
              case 'drivers':
                $scope.helpCaption = "HelpPrintQueuePropertiesDrivers";
                break;
              case 'computers':
                $scope.remoteQueueManagementCalibrationObject.supportedOs = reduceAmountOfOS();
                $scope.helpCaption = "HelpPrintQueuePropertiesComputers";
                $scope.remoteQueueManagementCalibrationObject.pagingObject = new WorkstationListPOSTPaging();
                $scope.remoteQueueManagementCalibrationObject.requestType = "POST";
                $scope.remoteQueueManagementCalibrationObject.context = "addOneQueuToManyWorkstations";
                $scope.remoteQueueManagementCalibrationObject.setHelpCaptionRemoteQueueManagement = "HelpPrintQueueuPropertiesRemoteQueueManagament";
                $scope.remoteQueueManagementCalibrationObject.resetHelpCaptionRemoteQueueManagement = "HelpPrintQueuePropertiesComputers";
                $scope.remoteQueueManagementCalibrationObject.tooltip = 'AddQueueToWorkstationsTooltip';
                break;
            }
          }
        }, true);

        $scope.queueNameInvalid = false;
        $scope.checQueuekName = function () {
          if ($scope.printQueue.info.name.match(/[\\,]/)) {
            $scope.queueNameInvalid = true;
          } else {
            $scope.queueNameInvalid = false;
          }
        }

        $scope.setHelpCaptionRemoteQueueManagement = function () {
          $scope.helpCaption = $scope.remoteQueueManagementCalibrationObject.setHelpCaptionRemoteQueueManagement;
        }

        $scope.resetHelpCaptionRemoteQueueManagement = function () {
          $scope.helpCaption = $scope.remoteQueueManagementCalibrationObject.resetHelpCaptionRemoteQueueManagement;
        }

        $scope.$watch(function () {
          return $scope.printQueueOriginal;
        }, function () {
          if ($scope.printQueueOriginal) {
            $scope.workstationListPaging.pagingCriteria.queue = $scope.printQueueOriginal.info._links.self.href;
            $scope.workstationListPaging.pagingCriteria.queueFilterMode = 'PRESENT';
            $scope.getWorkstationListPaged();
          }
        }, true)

        $scope.getWorkstationListPaged = function () {
          WorkstationListService.postGetWorkstationListPaged($scope.workstationListPaging).then(function (workstationContainer) {
            $scope.workstationContainer = workstationContainer;
          }).catch(function(error) {});
        };

        $scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if ($scope.workstationListPaging.pagingCriteria.page > 0) {
              $scope.workstationListPaging.pagingCriteria.page--;
            }
          } else {
            if ($scope.workstationListPaging.pagingCriteria.page + 1 < $scope.workstationContainer.page.totalPages) {
              $scope.workstationListPaging.pagingCriteria.page++;
            }
          }
          $scope.getWorkstationListPaged();
        }

        $scope.changeOrderByValue = function (textValue) {
          $scope.reverseWorkstations = !$scope.reverseWorkstations;
          if ($scope.reverseWorkstations) {
            $scope.workstationListPaging.pagingCriteria.direction = 'DESC';
          } else {
            $scope.workstationListPaging.pagingCriteria.direction = 'ASC';
          }
          $scope.workstationListPaging.pagingCriteria.sort = textValue;
          $scope.orderWorkstationsByText = SORT_WORKSTATIONS[textValue];
          $scope.getWorkstationListPaged();
        };

        $scope.editSelectedWorkstations = function (workstation, showSection) {
          if (workstation) {
            var url = URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id);
            $location.path(url).search(URL_PARAMS.SHOW_WORKSTATION_SECTION.ROUTE, showSection);
          } else {
            throw "$scope.editSelectedWorkstations: workstation is missing";
          }
        }


        //Printer queue **********************************************
        $scope.openPrinterProperties = function () {
          $scope.printerUrl = URLS.PRINTER_PROPERTIES.replace(URL_PARAMS.PRINTER_URL.LOCATION, $scope.printer.customProperties.id);
          $location.path($scope.printerUrl).search(URL_PARAMS.SHOW_PRINTER_SECTION.ROUTE, 'setup');
        };

        $scope.saveChanges = function (form, $event) {
          if (form && $event) {
            if (form.$invalid) {
              $event.preventDefault();
            } else {
              $scope.waitingForAnswer = true;
              $scope.printQueueOriginal.saveChanges($scope.printQueue).then(function (response) {
                $scope.waitingForAnswer = false;
                form.$setPristine();
                var message = "";
                if (response && response.data) {
                  message = $filter("translate")("ChangesSaved");
                } else {
                  message = $filter("translate")("NoChangesMade");
                }
                toastr.success(message);
              }).catch(function (error) {
                $scope.waitingForAnswer = false;
              });
            }
          } else {
            throw "$scope.saveChanges: form or $event are missing";
          }
        };

        function removeAndReplaceMacOS(operatingSystems) {
          var cleanOsList = [];
          var foundMAC_OS = false;
          angular.forEach(operatingSystems, function (os) {
            if (os.key.substring(0, 3) !== 'MAC') {
              cleanOsList.push(os);
            } else {
              foundMAC_OS = true;
            }
          })
          if (foundMAC_OS) {
            cleanOsList.push({ key: 'MAC_OS', value: 'macOS', index: 19 });
          }
          return cleanOsList;
        }

        function reduceAmountOfOS() {
          var reducedSupportedOs = [];
          if (TenantListService.currentTenant) {
            var avaliableOS = TenantListService.currentTenant.info._embedded.wsCountPerOs.wsCountPerOs;
            for (var key in avaliableOS) {
              for (var i = 0; i < SUPPORTED_OS.length; i++) {
                if (SUPPORTED_OS[i].key === key) {
                  reducedSupportedOs.push(SUPPORTED_OS[i]);
                }
              }
            }
            reducedSupportedOs = removeAndReplaceMacOS(reducedSupportedOs);
            return reducedSupportedOs;
          }
        }


        $scope.$watch(function () {
          return TenantListService.currentTenant;
        }, function () {
          if (TenantListService.currentTenant && TenantListService.currentTenant.info && TenantListService.currentTenant.info.groupsEnabled) {
            $scope.groupsEnabled = true;
          } else {
            $scope.groupsEnabled = false;
          }

          if (TenantListService.currentTenant) {
            calibrateTabs();
          }
        }, true);

        function chekcIfAnywhereRelatedQueue () {

          var signId = parseInt($scope.printQueue.info.signId);
          if (isNaN(signId)) {
            $scope.notAnywherePrinterQueue = true;
          } else {
            $scope.notAnywherePrinterQueue = false;
          }
        }


        function getPrintQueue () {
          var printQueueId = $routeParams[URL_PARAMS.PRINT_QUEUE_URL.ROUTE]
          var printerId = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE]
          if (printerId && printQueueId) {
            PrintQueueListService.getPrintQueueById(printerId, printQueueId).then(function (printQueue) {
              if (printQueue) {
                printQueue = mapGlobalPrinting(printQueue);
                checkUniversalPrintEnabled();
                $scope.printQueueOriginal = angular.copy(printQueue);
                $scope.remoteQueueManagementCalibrationObject.originalModel = $scope.printQueueOriginal;
                $scope.printQueue = $scope.printQueueOriginal;
                countOtherNetworks();
                chekcIfAnywhereRelatedQueue();
                getPrinter();
                getPreferredWorkstationsList(printQueue);
              } else {
                $location.path(URLS.HOME);
              }
            }).catch(function(error) {
              $location.path(URLS.HOME);
            });
          } else {
            $location.path(URLS.HOME);
          }
        }

        function getPreferredWorkstationsList (printQueue) {
          printQueue.getPreferredWorkstationsList().then(function(list){
            $scope.preferredWorkstationsList = list;
            decoratePreferredWithNetworkWarnings();
          }).catch(function(error){});
        }

        function extractNetworkHrefs(workstation) {
          const networks = workstation && workstation.info && workstation.info._embedded
            && Array.isArray(workstation.info._embedded.networks)
            ? workstation.info._embedded.networks
            : [];
          return networks
            .map(function (n) { return n && n._links && n._links.self ? n._links.self.href : null; })
            .filter(function (h) { return !!h; });
        }

        function getPrinterNetworkHref() {
          return $scope.network && $scope.network.info
            && $scope.network.info._links && $scope.network.info._links.self
            ? $scope.network.info._links.self.href
            : null;
        }

        function computeNetworkWarning(networkHrefs) {
          if (!Array.isArray(networkHrefs) || networkHrefs.length === 0) { return true; }
          const printerNetworkHref = getPrinterNetworkHref();
          if (!printerNetworkHref) { return false; }
          return networkHrefs.indexOf(printerNetworkHref) === -1;
        }

        function decoratePreferredWithNetworkWarnings() {
          if (!Array.isArray($scope.preferredWorkstationsList)) { return; }
          $scope.preferredWorkstationsList.forEach(function (ws) {
            if (ws && ws.info) {
              ws.info.networkWarning = computeNetworkWarning(extractNetworkHrefs(ws));
            }
          });
          $scope.anyNetworkWarnings = $scope.preferredWorkstationsList.some(function (ws) {
            return !!(ws && ws.info && ws.info.networkWarning);
          });
        }

        function getPrinter() {
          PrinterListService.getPrinterByURL(decodeURIComponent($scope.printQueueOriginal.info._links["px:printer"].href)).then(function (printer) {
            $scope.printer = angular.copy(printer);
            if ($scope.printQueueOriginal.info.publishUp) {
              $scope.siblingsOccupyUniversalPrint = false;
            } else if ($scope.printer.info._embedded.queues.length > 1){
              checkSiblingsForUniversalPrint($scope.printer.info._embedded.queues);
            } else {
              $scope.siblingsOccupyUniversalPrint = false;
            }
            getNetwork(printer);

            $scope.printerUrl = URLS.PRINTER_PROPERTIES.replace(URL_PARAMS.PRINTER_URL.LOCATION, $scope.printer.customProperties.id);
            $rootScope.secondaryHeadline = printer.info.signId + ", " + $scope.printQueue.info.name;
          }).catch(function (error) {
            $location.path(URLS.HOME);
          });
        }

        function countOtherNetworks () {
          $scope.otherNetworksCount = 0;
          if (Array.isArray($scope.printQueue.info._links['px:releaseFromOtherNetwork'])) {
            angular.forEach($scope.printQueue.info._links['px:releaseFromOtherNetwork'], function (network) {
              $scope.otherNetworksCount += 1;
            })
          } else {
            $scope.otherNetworksCount = 1;
          }
        }

        function mapGlobalPrinting (printQueue) {
          var globalPrinting = {
            global: printQueue.info.global,
            releaseFromOtherNetworksEnabled: printQueue.info.releaseFromOtherNetworksEnabled,
            viaTheCloud: printQueue.info.global || printQueue.info.releaseFromOtherNetworksEnabled ? true : false,

          }

          if (globalPrinting.viaTheCloud) {
            globalPrinting.printSetting = printQueue.info.global ? 'GLOBAL' : 'RELEASE_FROM_OTHER_NETWORKS_ENABLED'
          }

          printQueue.globalPrinting = globalPrinting;
          return printQueue;
        }

        $scope.toggleViaTheCloudSetting = function () {
          switch($scope.printQueue.globalPrinting.printSetting) {
            case 'GLOBAL':
              $scope.printQueue.info.global = true;
              $scope.printQueue.info.releaseFromOtherNetworksEnabled = false;
            break;
            case 'RELEASE_FROM_OTHER_NETWORKS_ENABLED':
              $scope.printQueue.info.global = false;
              $scope.printQueue.info.releaseFromOtherNetworksEnabled = true;
            break;
          }
        }

        $scope.toggleViaTheCloud = function () {

          if ($scope.printQueue.globalPrinting.viaTheCloud) {
            if (!$scope.printQueue.info.autoRemove && $scope.me.permissions.TENANT_ADMIN) {
              $scope.printQueue.info.global = true;
            } else {
              $scope.printQueue.info.releaseFromOtherNetworksEnabled = true;
            }
          } else {
            $scope.printQueue.info.global = false;
            $scope.printQueue.info.releaseFromOtherNetworksEnabled = false;
          }
          mapGlobalPrinting($scope.printQueue);
        }

        function checkSiblingsForUniversalPrint () {
          for (var i = 0; i < $scope.printer.info._embedded.queues.length; i++) {
            if ($scope.printer.info._embedded.queues[i].publishUp) {
              $scope.siblingsOccupyUniversalPrint = true;
              break;
            }
          }
        }

        function checkUniversalPrintEnabled () {
          if ($scope.tenant.info._embedded.tenantIdentityProviders.providers['azure']) {
            var azureDirectories = $scope.tenant.info._embedded.tenantIdentityProviders.providers.azure.directories;

            for (var key in azureDirectories) {
              if (azureDirectories[key].universal_print_enabled) {
                $scope.universalPrintEnabled = true;
                break
              }
            }
          }
        }

        function getNetwork (printer) {
          if (printer.info._links['px:network']) {
            var url = printer.info._links['px:network'].href;
            NetworkListService.getNetworkModelByUrl(url).then(function(network) {
              $scope.network = network;
              decoratePreferredWithNetworkWarnings();
              isThisResourceMine(network);
            }).catch(function(error) {});
          }
        }

        function isThisResourceMine (network) {
          var siteUrl = network.info._links['px:site'] ? network.info._links['px:site'].href : null;
          $scope.isThisResourceMine = $scope.me.isThisSiteMine(siteUrl);
        }

        $scope.selectAllItems = function() {
          angular.forEach($scope.workstationContainer.list, function(value) {
            value.options.isSelected = $scope.selectAllWorkstations.selected;
          });
        };

          $scope.$watch(function() {
            if ($scope.workstationContainer) {
              return $scope.workstationContainer.list;
            }
          }, function() {
            if ($scope.workstationContainer) {
              $scope.selectedWorkstations = $scope.workstationContainer.list.findAllElements({
                options: {
                  isSelected: true
                }
              }).length;
              if (!$scope.selectedWorkstations) {
                $scope.selectAllWorkstations.selected = false;
              } else {
                $scope.selectAllWorkstations.selected = ($scope.selectedWorkstations === $scope.workstationContainer.list.length);
              }
            }
          }, true);

          $scope.forceWorkstationsToGetLatestQueueUpdates = function() {
            var message = $filter('stringular')($filter('translate')('PrintQueueUpdateOnComputers'));
            $ngBootbox.confirm(message).then(function() {
              var workstationModel = $scope.workstationContainer.list[0];
              workstationModel.forceWorkstationsToGetLatestQueueUpdates($scope.printQueue, $scope.printer).then(function() {
                toastr.success($filter('stringular')($filter('translate')('PrintQueueUpdatedOnComputers'), $scope.printQueue.info.name));
              })
              .catch(function(error) {
                toastr.error($filter('translate')('UpsSomethingWentWrong'));
              });
            })
            .catch(function(error) {});
          }

        $scope.deleteWorkstations = function (workstation) {
          var workstations = [];
          var printerId = $scope.printer.info._links.self.href;

          if (workstation) {
            workstations.push(workstation.info);
          } else {
            var workstationsSelected = $scope.workstationContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            });
          }

          angular.forEach(workstationsSelected, function(workstation) {
            workstations.push(workstation.info);
          })

          if (workstations.length > 0) {
            var message = "";
            if (workstations.length < 2) {
              message = $filter("stringular")($filter("translate")("DeletePrintQueueOnComputer"), $scope.printQueueOriginal.info.name, workstations[0].name);
            } else {
              message = $filter("stringular")($filter("translate")("DeletePrintQueueOnComputers"), $scope.printQueueOriginal.info.name, workstations.length);
            }

            $ngBootbox.confirm(message).then(function() {
              $scope.printQueueOriginal.deleteSelectedWorkstations(workstations, printerId).then(function() {
                var message = "";
                if (workstations.length < 2) {
                  message = $filter("stringular")($filter("translate")("PrintQueueDeletedOnComputer"), $scope.printQueueOriginal.info.name, workstations[0].name);
                } else {
                  message = $filter("stringular")($filter("translate")("PrintQueueDeletedOnComputers"), $scope.printQueueOriginal.info.name, workstations.length);
                }
                toastr.success(message);
              }).catch(function(error) {});
            }).catch(function(error) {});
          } else {
            toastr.error($filter("translate")("SelectPrintQueueNone") + ", " + $filter("translate")("SelectPrintQueue"));
          }

        }




        ////////////////////////////////////
        ////////////////////////////////////
        //////  Open context menu
        ////////////////////////////////////
        $scope.openListMenu = function (event, context) {
          var menuItems = null;
          var icon = null;
          switch (context.type) {
            case 'networkMenu':
              menuItems = [
                {title: 'Networks', selected: false, type: 'networkList', breaker: true},
                {title: 'AddNetworks', selected: false, type: 'addToNetwork', breaker: false, disabled: $scope.me.isSystemObserver() && !$scope.isThisResourceMine},
                {title: 'RemoveNetworks', selected: false, type: 'removeNetworksFromQueue', breaker: false, disabled: $scope.me.isSystemObserver() && !$scope.isThisResourceMine},
              ];
              icon = 'icon-correct-network';
            break;
          }

          context.name = $filter("translate")(context.name);

          $scope.closeAllMenues();

          $timeout(function () {
            $scope.menuContent = {
              menuItems: menuItems,
              context: context,
              icon: icon,
              sizeClass: 'size115',
              type: 'ALLROUND'
            }
            $scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        $scope.closeAllMenues = function (newContext) {
          if (newContext) {
            openNewContext(newContext)
          } else {
            $scope.selectedContextMenuItem  =  null;
            $scope.contextPosition = null;
            $scope.context = null;
          }
        }

        function openNewContext (newContext) {
          $scope.openContextMenu(newContext.event, newContext, {type: newContext.type, title: newContext.title})
        }

        $scope.closeMenu = function (selection, position, content) {
          if (selection) {
            content.context.title = selection.title;
            $scope.openContextMenu({clientX: position.left, clientY: position.top}, content.context, selection)
          }
          $scope.menuContent = null;
          $scope.menuSpecs = null;
          $scope.contextContent = null;
        }

        $scope.openContextMenu = function (event, context, menuOption){
          $timeout(function  () {
            if (event, context, menuOption) {
              $scope.selectedContextMenuItem  =  menuOption;
              $scope.contextPosition = { left: event.clientX, top: event.clientY }
              $scope.context = context;
              $scope.context.printerNetwork = $scope.network;
              $scope.context.printer = $scope.printer;
              $scope.context.preferredWorkstationsList = $scope.preferredWorkstationsList;
              $scope.context.computeNetworkWarning = computeNetworkWarning;
              $scope.context.extractNetworkHrefs = extractNetworkHrefs;
              $scope.resource = $scope.tenant;
              $scope.auxiliaries = {
                me: $scope.me,
                isThisResourceMine: $scope.isThisResourceMine
              };
            }
          }, 50)
        }

        function enforceSaveChanges () {
          $scope.printQueueOriginal.saveChanges($scope.printQueue).then(function(response) {
            // console.log(response);
          }).catch(function(error) {
            console.log(error);
          });
        }


        function setListeners () {

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_UPDATED, function (name, data) {
            if (data.printQueue === $scope.printQueue.info._links.self.href) {
              getPrintQueue();
            }
          })

          // EVENTS LISTENERS CALLBACK
          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_ADDED, function () {
            $scope.supportedOs = reduceAmountOfOS();
          });

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_REMOVED, function () {
            $scope.supportedOs = reduceAmountOfOS();
          });

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_REMOVED, function () {
            $scope.supportedOs = reduceAmountOfOS();
          });
        }

        var PRINT_QUEUE_SAVE_ENFORCED_listener = $rootScope.$on('PRINT_QUEUE_SAVE_ENFORCED', function (name, printQueueId) {
          if (printQueueId === $scope.printQueue.info._links.self.href) {
            enforceSaveChanges();
          }
        })

        $scope.$on('$destroy', function() {
          PRINT_QUEUE_SAVE_ENFORCED_listener();
        });


      }
    ]);
})();
